import styled from "styled-components";
import { Box } from "@mui/material";

export const ModalContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 600px;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;
`;

export const Header = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const SearchBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 4px 8px;
  flex: 1;
`;

export const ChipsWrapper = styled(Box)`
  margin-bottom: 12px;
`;

export const BodyWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #333;
`;

export const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const ListItem = styled.li`
  padding: 6px 0;
  font-size: 14px;
  color: #444;
  border-bottom: 1px solid #f0f0f0;
`;
